// Scroll Animation
const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// Thumb Animation
const thumbItems = document.querySelectorAll(".thumb-animate");
function checkVisibility() {
    thumbItems.forEach(el => {
        const rect = el.getBoundingClientRect();
        const elementHeight = rect.height;
        const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

        if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
        }
    });
}
window.addEventListener("scroll", checkVisibility);
checkVisibility();



// Reveile Animation
function singleScrollReveal(className = ".reveal-group", visibleOffset = 150, delay = 300) {
    function runReveal() {
        $(className).each(function () {
            var $parent = $(this);
            var windowHeight = $(window).height();
            var elementTop = $parent.offset().top - $(window).scrollTop();

            if (elementTop < windowHeight - visibleOffset) {
                $parent.children().each(function (index) {
                    var $ele = $(this);
                    setTimeout(function () {
                        $ele.addClass("insight");
                    }, index * delay);
                });
            }
        });
    }
    $(window).on("scroll", runReveal);
    $(document).ready(runReveal);
}
singleScrollReveal();







$(document).ready(function () {
    function checkVisibility() {
        $('.fade-in-scroll').each(function () {
            var elementTop = $(this).offset().top;
            var viewportBottom = $(window).scrollTop() + $(window).height();
            if (elementTop < viewportBottom - 1) {
                $(this).addClass('is-show');
            }
        });
    }
    checkVisibility();
    $(window).on('scroll', function () {
        checkVisibility();
    });

});





// Header Sticky



function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;
        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');
        if (currentScroll <= 100) {
            header.style.transform = 'translateY(0)';
        }
        else if (currentScroll < lastScrollTop) {
            header.style.transform = 'translateY(0)';
            $('body').addClass('header-showing');
        }
        else {
            header.style.transform = 'translateY(-100%)';
            $('body').removeClass('header-showing');
        }
        lastScrollTop = currentScroll;
    });
}

headerSticky();






// hero slider start


$('.hero__left-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 800,
    fade: true,
    cssEase: 'linear'
});

// hero slider end




// gallery


if ($(Window).width() < 768) {
    $(".gallery__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
}



if ($(Window).width() < 768) {
    $('.featured-objects__items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
    });
}


$('.featured-objects__left-arrow').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.featured-objects__right-arrow').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
});



if ($(Window).width() < 768) {
    $('.product-news__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}


$('.product-news__left-arrow').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product-news__right-arrow').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
});



// menu-drawer accordion start


$(".menu-drawer__has-menu > a").click(function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next(".menu-drawer__has-menu-content").slideUp();
    } else {
        $(".menu-drawer__has-menu-content").slideUp();
        $(".menu-drawer__has-menu > a").removeClass("active");
        $(this).addClass("active");
        $(this).next(".menu-drawer__has-menu-content").slideDown();
    }
});
$(".menu-drawer__has-have-menu > a").click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).next(".menu-drawer__has-have-menu-content").slideUp();
    } else {
        $(".menu-drawer__has-have-menu-content").slideUp();
        $(".menu-drawer__has-have-menu > a").removeClass("active");
        $(this).addClass("active");
        $(this).next(".menu-drawer__has-have-menu-content").slideDown();
    }
});



$(".header__mobi-menu").on("click", function () {
    $("body").addClass("menu-open");
})
$(".header__close").on("click", function () {
    $("body").removeClass("menu-open");
})


$(".has-megamenu").hover(function () {
    $(".header__inner").toggleClass("megamenu-show");
});


// menu-drawer accordion end




$(document).ready(function () {
    $('.breadcrumb__inner ul li:last-child').addClass('active');
});


// single-product slider start

$('.single-product__big-items').slick({
    initialSlide: 1,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    dots: false,
    adaptiveHeight: true,
    asNavFor: '.single-product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
            }
        },
    ]
});
$('.single-product__small-items').slick({
    // initialSlide: 1,
    slidesToShow: 10,
    slidesToScroll: 1,
    asNavFor: '.single-product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});


// single-product slider end


function handleLoading($btn, duration = 1200) {
    const $parent = $btn.parent();

    clearTimeout($parent.data("loadingTimeout"));

    $parent.addClass("loading");

    const timeoutId = setTimeout(function () {
        $parent.removeClass("loading");
    }, duration);

    $parent.data("loadingTimeout", timeoutId);
}

// $(document).on("click", ".click-loading", function (e) {
//     e.preventDefault();
//     handleLoading($(this));
// });





$('.brand-pillars__items').on('init reInit afterChange', function (event, slick, currentSlide) {
    var index = (currentSlide !== undefined ? currentSlide : 0) + 1;
    var total = slick.slideCount;
    var current = index < 10 ? '0' + index : index;
    var totalSlides = total < 10 ? '0' + total : total;
    $('.brand-pillars__slider-number').html(
        '<p>' + current + '</p>' +
        '<p>/</p>' +
        '<p>' + totalSlides + '</p>'
    );
});

var bgClasses = [
    'bg-deep-oxblood',
    'bg-midnight-navy',
    'bg-dark-maroon'
];

$('.brand-pillars__items').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var colorIndex = nextSlide % bgClasses.length;
    $('.brand-pillars__inner')
        .removeClass(bgClasses.join(' '))
        .addClass(bgClasses[colorIndex]);
});

$('.brand-pillars__items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
    speed: 300,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                fade: false
            }
        }
    ]
});

$('.brand-pillars__arrow-left').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickPrev');
});

$('.brand-pillars__arrow-right').click(function () {
    $(this).parent().parent().parent().parent().parent().parent().find('.slick-slider').slick('slickNext');
});




// $('.featured-objects-card__star').click(function () {
//     $(this).toggleClass('active');
// });



// $(document).ready(function () {
//     function setBigImgHeight() {
//         if ($(window).width() > 1023) {
//             $('.featured-objects-card_big-img').css('height', 'calc(100% - ' + ($('.featured-objects-card:not(.featured-objects-card_big-img) .featured-objects-card__text').outerHeight(true) + 35) + 'px)');
//         }
//     }
//     setBigImgHeight();
//     $(window).on('resize', setBigImgHeight);
// });

$(window).on('load', function () {
    var firstCardHeight = $('.shop-item__grids .featured-objects-card').first().outerHeight() - 123;
    $('.featured-objects-card_big-img').css('height', firstCardHeight);
    console.log('card height '+firstCardHeight);
});





// Accordion 

$(".accordion__title").first().addClass("active")
    .next(".accordion__content").show();
$(".accordion__title.active")
    .next(".accordion__content")
    .show();
$(".accordion__title").on("click", function (e) {
    e.preventDefault();
    var $this = $(this);
    var $content = $this.next(".accordion__content");
    $(".accordion__content").stop(true, true);
    $(".accordion__title").not($this).removeClass("active");
    $(".accordion__content").not($content).slideUp(400);
    $this.toggleClass("active");
    $content.slideToggle(400);
});





// shop-item-tab start


$('.shop-item__tab').on('click', function () {
    $('.shop-item__tab').removeClass('active');
    $(this).addClass('active');
});


// shop-item-tab end



// cart-drawer start


$(".header__cart, .menu-drawer__cart a").on("click", function (e) {
    e.preventDefault();
    $("body").addClass("cart-open");
})
$(document).on('click', '.cart-drawer__close', function(){
$("body").removeClass("cart-open");
})
$(".overlay").on("click", function () {
    $("body").removeClass("cart-open");
})


// cart-drawer end



// Start Form Tab

$(document).ready(function () {
    $('.register__menu > p').on('click', function (e) {
        e.preventDefault();
        var tabName = $(this).data('tab');
        $('.register__menu > p').removeClass('active');
        $(this).addClass('active');
        $('.register__item').removeClass('active');
        $('.register__item').each(function () {
            if ($(this).attr('tab-content') === tabName) {
                $(this).addClass('active');
            }
        });
    });
});

// Start Form Tab



// start Colleciton Filter Sort


$(document).ready(function () {
  const isMobile = () => window.innerWidth < 1024;

  function closeAll() {
    $('.shop-item__filter-title').removeClass('active');

    if (isMobile()) {
      $('.shop-item__filter-content').stop(true, true).slideUp(200).removeClass('active');
    } else {
      $('.shop-item__filter-content').hide().removeClass('active');
    }
  }

  function positionContent($title, $content) {
    if (isMobile()) return;

    const titleOffset = $title.offset();
    const wrapOffset = $('.shop-item__filter-wrap').offset();

    $content.css({
      position: 'absolute',
      top: titleOffset.top - wrapOffset.top + $title.outerHeight() + 30,
      left: titleOffset.left - wrapOffset.left + 90
    });
  }

  $(document).on('click', '.shop-item__filter-title', function (e) {
    e.stopPropagation();

    const $title = $(this);
    const id = $title.data('filter');
    const $content = $('#' + id);

    if (!$content.length) return;

    if ($title.hasClass('active')) {
      closeAll();
      return;
    }

    closeAll();

    $title.addClass('active');
    $content.addClass('active');

    if (isMobile()) {
      $content.stop(true, true).slideDown(200);
      $('.shop-item__filter-bodys').slideDown();
    } else {
      positionContent($title, $content);
      $content.show();
    }
  });

  $(document).on('click', '.shop-item__filter-wrap', function (e) {
    e.stopPropagation();
  });

  $(document).on('click', function () {
    closeAll();
  });

  $(window).on('resize', function () {
    closeAll();
  });
});



    


$(document).on('change', '.shop-item__filters input[type="radio"]', function () {
  var selectedTags = [];
  var sortValue = '';
  var collectionValue = '';

  $('.shop-item__filters input[type="radio"]:checked').each(function () {
    var name = $(this).attr('name');
    var value = $(this).val();

    if (!value) return;

    if (name === 'sort') {
      sortValue = value;
    } else if (name === 'collection') {
      collectionValue = value;
    } else {
      selectedTags.push(value);
    }
  });

  var collectionUrl = collectionValue
    ? '/collections/' + collectionValue
    : window.location.pathname.split('/').slice(0, 3).join('/');

  var newUrl = collectionUrl;

  if (selectedTags.length) {
    newUrl += '/' + selectedTags.join('+');
  }

  if (sortValue) {
    newUrl += '?sort_by=' + encodeURIComponent(sortValue);
  }

  $.ajax({
    url: newUrl,
    type: 'GET',
    success: function (response) {
      var newGrid = $(response).find('.shop-item__inner').html();
      var newHero = $(response).find('.shop-hero__wrapper').html();

      $('.shop-item__inner').html(newGrid);
      $('.shop-hero__wrapper').html(newHero);

      window.history.pushState({}, '', newUrl);
    }
  });
});

// End Colleciton Filter Sort



// search start


$(".header__search, .menu-drawer__search").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $("body").addClass("search-show");
});
$(".search__close").on("click", function () {
    $("body").removeClass("search-show");
});
$(document).on("click", function (e) {
    if (!$(e.target).closest(".search").length) {
        $("body").removeClass("search-show");
    }       
});
$(document).on("click", '.cart-drawer__bottom h3', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(".cart-note").slideToggle();
});


// search end










// product zoom

$(document).ready(function () {
    var SCALE = 2;
    var isDragging = false, hasDragged = false;
    var startX = 0, startY = 0, currentX = 0, currentY = 0;
    var isDesktopZoomed = false, isTouchDragging = false;
    var touchStartX = 0, touchStartY = 0;
    var isMobile = window.innerWidth <= 768;
    var $body = $('body'), $modalImg = $('.zoom-modal__img');
    function getImg() { return $('.zoom-modal .slick-current img'); }
    function clampTranslate(x, y, img) {
        var vw = window.innerWidth, vh = window.innerHeight;
        var lx = Math.max(0, (img.offsetWidth * SCALE - vw) / 2) / SCALE;
        var ly = Math.max(0, (img.offsetHeight * SCALE - vh) / 2) / SCALE;
        return { x: Math.max(-lx, Math.min(lx, x)), y: Math.max(-ly, Math.min(ly, y)) };
    }
    function applyTransform(x, y) {
        var img = getImg()[0];
        if (!img) return;
        var c = clampTranslate(x, y, img);
        currentX = c.x; currentY = c.y;
        getImg().css('transform', 'scale(' + SCALE + ') translate(' + currentX + 'px,' + currentY + 'px)');
    }
    function snapToCenter() {
        currentX = 0; currentY = 0;
        getImg().css({ transition: 'transform 0.35s ease', transform: 'scale(' + SCALE + ') translate(0px,0px)' });
        setTimeout(function () { getImg().css('transition', ''); }, 350);
    }
    function reset() {
        currentX = 0; currentY = 0;
        isDragging = false; isTouchDragging = false;
        $('.zoom-slide img').removeClass('is-zoomed is-dragging').css({ transform: 'scale(1) translate(0,0)', transition: '' });
    }
    function applyZoom() {
        getImg().addClass('is-zoomed').css('transform', 'scale(' + SCALE + ') translate(0,0)');
    }
    function buildSlider(index) {
        var $slider = $('<div class="zoom-slider"></div>');
        $('.single-product__big-item:not(.slick-cloned)').each(function () {
            $slider.append('<div class="zoom-slide"><img src="' + $(this).find('img').attr('src') + '" alt="' + ($(this).find('img').attr('alt') || '') + '"></div>');
        });
        $modalImg.empty().append($slider);
        $slider.slick({ initialSlide: index, infinite: true, slidesToShow: 1, slidesToScroll: 1, arrows: false, dots: false, swipe: false, draggable: false, touchMove: false });
        reset(); isDesktopZoomed = false;
    }
    function open(index, autoZoom) {
        buildSlider(index);
        if (autoZoom && isMobile) setTimeout(applyZoom, 50);
        $('.zoom-modal').addClass('flex-show');
        $body.css('overflow', 'hidden');
    }
    function close() {
        var $slider = $('.zoom-slider');
        if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
        $modalImg.empty();
        $('.zoom-modal').removeClass('flex-show');
        $body.css('overflow', '');
        reset(); isDesktopZoomed = false;
    }
    $(document).on('click', '.single-product__mobi-plus-icon', function () {
        open($('.single-product__big-items').slick('slickCurrentSlide'), true);
    });
    $(document).on('click', '.single-product__big-item', function () {
        if (!isMobile) open($(this).index() - 1, false);
    });
    $(document).on('click', '.zoom-modal .slick-current img', function () {
        if (isMobile) return;
        if (hasDragged) { hasDragged = false; return; }
        if (isDesktopZoomed) { reset(); isDesktopZoomed = false; }
        else { applyZoom(); isDesktopZoomed = true; }
    });
    $(document).on('afterChange', '.zoom-slider', function () {
        reset(); isDesktopZoomed = false;
        if (isMobile) setTimeout(applyZoom, 50);
    });
    $(document).on('click', '.zoom-modal__close', close);
    $(document).on('click', '.zoom-modal__left-arrow', function () { $('.zoom-slider').slick('slickPrev'); });
    $(document).on('click', '.zoom-modal__right-arrow', function () { $('.zoom-slider').slick('slickNext'); });
    $(document).on('click', '.zoom-modal', function (e) { if ($(e.target).hasClass('zoom-modal')) close(); });
    $(document).on('mousedown', '.zoom-modal .slick-current img.is-zoomed', function (e) {
        if (isMobile) return;
        isDragging = true; hasDragged = false;
        $(this).addClass('is-dragging');
        startX = e.clientX - currentX; startY = e.clientY - currentY;
        e.preventDefault();
    });
    $(document).on('mousemove', function (e) {
        if (!isDragging || !getImg().hasClass('is-zoomed')) return;
        hasDragged = true;
        applyTransform(e.clientX - startX, e.clientY - startY);
    });
    $(document).on('mouseup', function () {
        if (isDragging && hasDragged) snapToCenter();
        isDragging = false;
        $('.zoom-slide img').removeClass('is-dragging');
    });
    document.addEventListener('touchstart', function (e) {
        if (!document.querySelector('.zoom-modal .slick-current img.is-zoomed')) return;
        if (!e.target.closest('.zoom-modal .slick-current img') || e.touches.length !== 1) return;
        isTouchDragging = true;
        touchStartX = e.touches[0].clientX - currentX;
        touchStartY = e.touches[0].clientY - currentY;
        e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchmove', function (e) {
        if (!isTouchDragging || e.touches.length !== 1 || !getImg().hasClass('is-zoomed')) return;
        applyTransform(e.touches[0].clientX - touchStartX, e.touches[0].clientY - touchStartY);
        e.preventDefault();
    }, { passive: false });
    document.addEventListener('touchend', function () { isTouchDragging = false; });
});





$(function () {
  let loading = false;

  function infiniteScroll() {
    const $pagination = $('.infinite-scroll-pagination');
    const $nextLink = $('.infinite-scroll-next');

    if (!$pagination.length || !$nextLink.length || loading) return;

    const paginationTop = $pagination.offset().top;
    const scrollBottom = $(window).scrollTop() + $(window).height();

    if (scrollBottom >= paginationTop) {
      loading = true;

      $.ajax({
        url: $nextLink.attr('href'),
        type: 'GET',
        success: function (response) {
          const $html = $(response);

          const newProducts = $html.find('.shop-item__grids').html();
          const newNextUrl = $html.find('.infinite-scroll-next').attr('href');

          $('.shop-item__grids').append(newProducts);

          if (newNextUrl) {
            $nextLink.attr('href', newNextUrl);
          } else {
            $pagination.remove();
          }

          loading = false;
        },
        error: function () {
          loading = false;
        }
      });
    }
  }

  $(window).on('scroll', infiniteScroll);
});